// ==================================================
// MARKETING: Edit "For Investors" page content here
// ==================================================

export const investorsHero = {
  headline: 'Built for Property Investors',
  subheadline: 'Make data-driven investment decisions with confidence',
  ctaText: 'Start Investing Smarter',
  ctaLink: 'https://propertyforecast.co/?ref=hf',
  image: '/images/investors-placeholder.png',
}

export const investorsFeatures = [
  {
    title: 'ROI Predictions',
    description: 'Forecast your return on investment before you buy',
    icon: '💰',
  },
  {
    title: 'Market Analysis',
    description: 'Understand local market trends and opportunities',
    icon: '📈',
  },
  {
    title: 'Risk Assessment',
    description: 'Identify potential risks before making a purchase',
    icon: '🛡️',
  },
]

export const investorsCTA = {
  headline: 'Start making smarter investments',
  subheadline: 'Join successful investors using PropertyForecast',
  ctaText: 'Get Started',
  ctaLink: 'https://propertyforecast.co/?ref=hf',
}
